import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.5 13q-2.725 0-4.612-1.887T0 6.5t1.888-4.612T6.5 0t4.613 1.888T13 6.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6q-.75.6-1.725.95T6.5 13m0-2q1.875 0 3.188-1.312Q11 8.375 11 6.5T9.688 3.313 6.5 2 3.313 3.313 2 6.5t1.313 3.188T6.5 11"
    }, null, -1)
  ]))]))
}
export default { render: render }